// extracted by mini-css-extract-plugin
export default {"container":"Page_container__PGHOC","fullView":"Page_fullView__TMFGb","shimmer":"Page_shimmer__KOVWl"};